import { TrustPilotMicroReviewCount as UITrustPilotMicroReviewCount } from "@jti/ui/components/TrustPilotMicroReviewCount/TrustPilotMicroReviewCount";

import type { TrustPilotMicroReviewCountProps } from "./TrustPilotMicroReviewCount.builder";

export function TrustPilotMicroReviewCount(props: TrustPilotMicroReviewCountProps) {
  return (
    <UITrustPilotMicroReviewCount
      styleHeight={props.styleHeight}
      styleWidth={props.styleWidth}
      theme={props.theme}
      minReviewCount={props.minReviewCount}
      styleAlignment={props.styleAlignment}
    />
  );
}
